import { Currency } from '@/core/currency/interfaces';

const TZS: Currency = {
    name: 'Tanzanian Shilling',
    demonym: 'Tanzanian',
    majorSingle: 'Shilling',
    majorPlural: 'Shillings',
    codeNumeric: '834',
    symbol: 'TSh',
    symbolNative: 'TSh',
    minorSingle: 'Senti',
    minorPlural: 'Senti',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'TZS',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default TZS;
